import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {MatTableDataSource} from '@angular/material';
import { AlunoService } from '../../../services/aluno-service';
import { Aluno } from '../../../models/aluno';

@Component({
  selector: 'app-lista-aluno',
  templateUrl: './lista-aluno.component.html',
  styleUrls: ['./lista-aluno.component.scss']
})
export class ListaAlunoComponent implements OnInit {

  alunos: Aluno[] = []
  displayedColumns = ['matricula', 'nome', 'cpf'];
  dataSource: any
  constructor(public alunoService: AlunoService) {
  }

  ngOnInit() {
    this.alunoService.getSnapshot().then((res)=>{
      res.forEach(res=>{
        var aluno = res.val()
        aluno.id = res.key
        this.alunos.push(aluno)
      })
      this.alunos.sort(this.compare);
      this.dataSource = new MatTableDataSource(this.alunos)
    })
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  compare(a, b) {
    if(a.nome < b.nome)
      return -1;
    return 1;
  }
}
